import React, {useCallback, useEffect, useRef, useState} from 'react'
import {isAxiosError} from 'axios'
import {useSWRConfig} from 'swr'
import styles from './entry.module.css'
import {useTranslation} from 'react-i18next'
import {Button, Col, Input, message} from 'antd'
import {showApiError, showMessage} from '../../../common/message'
import {queries} from '../../../api/queries'
import http from '../../../services/http.service'
import PopupSpinner from '../../molecules/spinner/PopupSpinnerView'
import {useNavigate, useParams} from "react-router-dom";
import { trackingDetailUrl } from "../../../common/consts.common";

export const SearchScreen = () => {
    const navigate = useNavigate()
    const {tracking} = useParams()
    const {mutate} = useSWRConfig()
    const {t} = useTranslation('tracking')
    const [messageApi, messageHolder] = message.useMessage();
    const [trackingNumber, setTrackingNumber] = useState(tracking || '')
    const autoSearchedTracking = useRef<string>()
    const [loading, setLoading] = useState(false)

    const handleChangeDelivery = (e: any | { target: { value: string } }) => {
        setTrackingNumber(e.target.value)
    }

    const search = useCallback(async (tracking_number: string, automatic = false) => {
        if (!tracking_number) {
            showMessage(messageApi, t('popup.error.tracking.empty'))
            return
        }
        setLoading(true)
        try {
            const key = queries.shipping.info(tracking_number)
            const {data} = await http.get(key)
            await mutate(key, data, {revalidate: false})
            if (automatic) {
                navigate(trackingDetailUrl(tracking_number), {replace: true})
            } else {
                navigate(trackingDetailUrl(tracking_number))
            }
        } catch (error) {
            if (isAxiosError(error) && error.response?.status === 404) {
                showMessage(messageApi, t('search.notfound.label1'), 'warning')
            } else {
                showApiError(error, messageApi)
            }
        } finally {
            setLoading(false)
        }
    }, [messageApi, mutate, navigate, t])

    useEffect(() => {
        if (autoSearchedTracking.current === tracking) return
        autoSearchedTracking.current = tracking
        setTrackingNumber(tracking || '')
        if (tracking) void search(tracking, true)
    }, [tracking, search])

    const handleSearch = (event: React.FormEvent<HTMLFormElement>) => {
        event.preventDefault()
        if (!loading) void search(trackingNumber)
    }

    return (
        <Col className={'inner-container column ' + styles.searchInner}>
            {messageHolder}
            <div className={styles.title}>
                <div className={'title ' + styles.subtitle}>{t('search.subtitle')}</div>
                <div className={'body ' + styles.label}>{t('search.label')}</div>
            </div>
            <form
                onSubmit={handleSearch}>
                <Input
                    maxLength={24}
                    size={"large"}
                    value={trackingNumber}
                    autoComplete={'off'}
                    autoFocus
                    placeholder={t('search.input.place')}
                    data-cy={'deliveryID'}
                    onChange={handleChangeDelivery}
                />
                <Button type={'primary'} size={"large"} block data-cy={'submitID'} className={styles.button}
                        htmlType={'submit'} disabled={loading}>
                    {t('search.btn')}
                </Button>
            </form>
            {loading && <PopupSpinner/>}
        </Col>
    )
}
